import React, { useState, useEffect, Fragment } from 'react'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate, Redirect } from 'react-router-dom';
import { FiEye } from "react-icons/fi"
import { AiFillEyeInvisible } from "react-icons/ai";
import { auth_user, getUserInfo } from '../../services/http';
import { toast } from 'react-toastify';
import ProcessSpinner from '../../components/ProcessSpinner/ProcessSpinner';
import { ImMail3 } from 'react-icons/im';
import axios from 'axios';
import { BASE_URL } from '../../constants/constants';
import "./PasswordForgotten.css"


const PasswordForgotten = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);

    const [processOngoing, setProcessOngoing] = useState(false)


    const [mail, setMail] = useState("");

    const [showErrorMail, setShowErrorMail] = useState(false)
    const [mailErrorMessage, setMailErrorMessage] = useState("")


    const [dataLoading, setDataLoading] = useState(false);

    const [showMailSentBox, setShowMailSentBox] = useState(false);

    useEffect(() => {
        if (mail !== "") {
            setShowErrorMail(false)
        }
    }, [mail])



    const handleSubmitMail = async (e) => {
        setProcessOngoing(true)
        e.preventDefault()
        console.log("Credentials are ", mail)
        axios.post(`${BASE_URL}api/reset-UserPassword`, { email: mail })
            .then(res => {
                setProcessOngoing(false)
                console.log(res);
                console.log(res.data);
                // toast.success(`Succès !`, {
                //     position: toast.POSITION.TOP
                // });
                setShowMailSentBox(true)

            })
            .catch(error => {
                setProcessOngoing(false)
                console.log(error.response)
                if (error.response.status === 422) {
                    if (error.response?.data.error?.email) {
                        var errorMsg = error.response?.data.error.email[0];
                        setShowErrorMail(true)
                        setMailErrorMessage(errorMsg)
                    } else {
                        var errorMsg = error.response?.data;
                        setShowErrorMail(true)
                        setMailErrorMessage(errorMsg)
                    }
                }
            })

            ;
    }

    //   Start
    // const handleDisplayPassword = () => {
    //     if (showPassword === true) {
    //         setShowPassword(false)
    //     } else {
    //         setShowPassword(true)
    //     }
    // }


    const handleInputChange = (e) => {
        const value = e.currentTarget.value;
        setMail(value)
    }


    return (

        <div className="form-container">
            <div className="form-form">
                <div className="form-form-wrap">
                    <div className="form-container">
                        <div className="form-content" style={{ paddingTop: "50%" }}>

                            <h1 className="">Réinitialisation mot de passe
                                {/* <a href="index.html"><span className="brand-name">Supervision BCC</span></a> */}
                            </h1>
                            <p className="signup-link"></p>
                            {/* <p className="signup-link">Nouveau ? <a href="auth_register.html">Créer un compte</a></p> */}

                            <form className="text-left">
                                <div className="form">

                                    <div id="username-field" className="field-wrapper input">
                                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" margin-left="15px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-mail"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> */}
                                        {showMailSentBox === false && <><ImMail3 style={{ width: 2_4, height: 24, marginLeft: 15, marginRight: 15, viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round" }} className="feather feather-mail" />
                                            <input style={{ marginLeft: 10 }}
                                                id="username"
                                                value={mail}
                                                onChange={(e) => handleInputChange(e)}
                                                name="username" type="text"
                                                className={showErrorMail === true ? "form-control new-agent-error-input custom-form-control" : "form-control custom-form-control"}
                                                placeholder="Email" />
                                            {showErrorMail === true && <span className="new-agent-error-span ml-2">{mailErrorMessage}</span>}</>}
                                        {showMailSentBox === true && <>
                                        <div className='info-box mx-auto'><p className='text-dark'>Un mail de réinitialisation de votre mot de passe a été envoyé à votre adresse mail <b><em>{mail}</em></b></p>
                                        </div>
                                        <div className="text-right mt-2 d-flex justify-content-end">
                                        <button onClick={() => navigate("/auth")} className="ml-2 btn btn-dark d-flex align-self-end">
                                            {/* {dataLoading === true && <span className="spinner-border text-white mr-2 pb-2 custom-spinner-auth "></span>} */}
                                            <span className="">Quitter</span>
                                        </button>
                                        </div>
                                        </>
                                        }
                                    </div>

                                    {showMailSentBox === false && <div className="field-wrapper text-right d-flex justify-content-end">

                                        {processOngoing == false ? <button disabled={dataLoading} onClick={(e) => handleSubmitMail(e)} className="btn btn-primary d-flex align-self-end">
                                            {/* {dataLoading === true && <span className="spinner-border text-white mr-2 pb-2 custom-spinner-auth "></span>} */}
                                            <span className="">Envoyer</span>
                                        </button> :
                                            <ProcessSpinner />}

                                        <button onClick={() => navigate("/auth")} className="ml-2 btn btn-dark d-flex align-self-end">
                                            {/* {dataLoading === true && <span className="spinner-border text-white mr-2 pb-2 custom-spinner-auth "></span>} */}
                                            <span className="">Quitter</span>
                                        </button>
                                    </div>}

                                    <div className="field-wrapper text-center keep-logged-in">

                                    </div>

                                </div>
                            </form>
                            <p className="terms-conditions" style={{ marginTop: 0 }}><span style={{ color: '#256CE2', fontWeight: 'bold' }}>Supervision du TEG </span> © 2022 Tous droits réservés</p>

                        </div>
                    </div>
                </div>
            </div>
            <div className="form-image">
                <div className="l-image">
                </div>
            </div>
        </div>
    )
}

export default PasswordForgotten